(() => {
  const data = document.getElementById('SteepAovCartData');
  if (!data) return;
  let config;
  try { config = JSON.parse(data.textContent); } catch (_) { return; }
  if (Number(config.themeId) !== 238277689400) return;
  const t = config.shippingEstimator;
  const a = t.auto;
  if (!a) return;
  const root = window.Shopify?.routes?.root || '/';
  const lower48 = new Set('AL AZ AR CA CO CT DE DC FL GA ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY'.split(' '));
  const eligible = new Set(config.shippingEligibleVariantIds.map(String));
  const trials = new Set(config.freeShippingTrialVariantIds.map(String));
  const panels = new Map();
  const cache = new Map();
  let destination = null;
  let locationPending = true;
  let locationVersion = 0;
  let cartModel;
  const currency = config.currency || 'USD';
  const money = (cents, code = currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:code}).format(cents / 100);
  const escape = value => String(value ?? '').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#39;');
  const subscription = model => model.items.some(item => item.selling_plan_allocation);
  const paid = model => model.items.filter(item => Number(item.final_line_price) > 0);
  const isTrial = model => paid(model).some(item => trials.has(String(item.variant_id)));
  const totalEligible = model => paid(model).reduce((sum,item) => sum + (eligible.has(String(item.variant_id)) && !trials.has(String(item.variant_id)) ? Number(item.final_line_price) : 0),0);
  const regionAllowed = () => destination?.country === 'US' && lower48.has(destination.regionCode);
  const complete = () => destination && /^[A-Z]{2}$/.test(destination.country || '') && /^[A-Z0-9 -]{2,12}$/.test(destination.postalCode || '') && (destination.country !== 'CA' || /^[A-Z]{2}$/.test(destination.regionCode || '')) && (destination.country !== 'US' || lower48.has(destination.regionCode) || ['AK','HI','AA','AE','AP','PR','VI','GU','MP','AS'].includes(destination.regionCode));
  const fingerprint = model => JSON.stringify([model.currency,model.total_price,model.items.map(item => [item.key || item.variant_id,item.quantity,item.final_line_price,item.selling_plan_allocation?.selling_plan?.id || null]),model.discount_codes || []]);
  const signature = model => JSON.stringify([fingerprint(model),destination,locationVersion]);
  const policy = model => {
    const subtotal = totalEligible(model);
    const threshold = Number(config.shippingThresholdCents || 6000);
    const remaining = Math.max(0,threshold-subtotal);
    let message = regionAllowed() ? (remaining ? a.remaining.replace('{amount}',money(remaining,model.currency)) : a.threshold) : a.offer;
    if (destination?.country && (destination.country !== 'US' || ['AK','HI'].includes(destination.regionCode))) message = a.excluded;
    if (isTrial(model) && paid(model).every(item=>trials.has(String(item.variant_id)))) message = a.trial;
    if (subscription(model)) message = t.subscription;
    return {message,progress:Math.min(100,Math.max(0,subtotal/threshold*100))};
  };
  const style = document.createElement('style');
  style.textContent = `
.steep-auto-shipping{margin:16px 0 12px;padding:0;border:0;font-size:13px;line-height:1.45;color:#292522}
.steep-auto-shipping p{margin:0}
.steep-auto-quote{display:flex;align-items:baseline;justify-content:space-between;gap:16px;font-size:14px}
.steep-auto-quote strong{font-weight:650;white-space:nowrap;font-variant-numeric:tabular-nums}
.steep-auto-location-row{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:34px;color:#716963;font-size:12px}
.steep-auto-location-row [data-auto-location]{min-width:0}
.steep-auto-shipping button[data-auto-change]{min-height:34px;min-width:44px;padding:4px 0;border:0;border-radius:0;background:none;color:#9e372e;font:inherit;font-size:12px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
.steep-auto-track{height:3px;border-radius:4px;background:#9e372e20;margin:2px 0 7px;overflow:hidden}
.steep-auto-fill{height:100%;background:#9e372e;width:var(--progress,0%);border-radius:inherit}
.steep-auto-shipping [data-auto-policy]{font-size:12px;color:#716963}
.steep-auto-shipping [data-auto-policy] strong{font-weight:650;color:#403731}
.steep-auto-shipping [data-auto-status]{font-size:12px;color:#716963;margin-top:6px}
.steep-auto-footer{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-top:6px;font-size:11px;color:#8a8078}
.steep-auto-footer>small{font-size:inherit}
.steep-auto-details{font-size:11px;color:#716963}
.steep-auto-details summary{display:inline-block;padding:5px 0;cursor:pointer;color:#716963;list-style:none;text-decoration:underline;text-underline-offset:3px}
.steep-auto-details summary::-webkit-details-marker{display:none}
.steep-auto-details[open]{flex:1}
.steep-auto-details[open] summary{float:right}
.steep-auto-details p{clear:both;padding-top:5px;max-width:55ch}
.steep-auto-shipping form{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:4px 0 12px;padding:12px;border:1px solid #9e372e25;border-radius:8px;background:#9e372e05}
.steep-auto-shipping form[hidden],.steep-auto-shipping [hidden]{display:none!important}
.steep-auto-shipping label{display:block;font-size:12px}
.steep-auto-shipping label:last-of-type{grid-column:1/-1}
.steep-auto-shipping input{display:block;width:100%;box-sizing:border-box;min-height:44px;margin-top:4px;font:inherit;padding:8px;border:1px solid #71696355;border-radius:4px;background:transparent;color:inherit}
.steep-auto-shipping form button{grid-column:1/-1;min-height:44px;padding:8px 12px;border:1px solid #9e372e55;border-radius:5px;background:transparent;color:#9e372e;font:inherit;cursor:pointer}
.steep-auto-shipping :focus-visible{outline:2px solid #9e372e;outline-offset:3px}
#cart-drawer .steep-auto-shipping{margin:16px 0 12px}
#cart-drawer .steep-auto-footer>small{display:none}
.steep-auto-shipping-ready .shipping-summary{display:none}
@media(max-width:480px){.steep-auto-shipping{margin-top:14px}.steep-auto-quote{font-size:13px}.steep-auto-details summary{min-height:28px;box-sizing:border-box}.steep-auto-shipping button[data-auto-change]{min-height:40px}}
`;

  document.head.append(style);
  const setText = (panel,selector,text) => { const node = panel.querySelector(selector); if (node.textContent !== text) node.textContent = text; };
  const status = (state,text) => {
    setText(state.panel,'[data-auto-status]',text);
    state.panel.querySelector('[data-auto-status]').hidden=!text;
    if(text){setText(state.panel,'[data-auto-price]','—');setText(state.panel,'[data-auto-service]','');}
  };
  const updatePolicy = (state) => {
    const result = policy(state.model);
    const policyText=subscription(state.model)?'':result.message;
    let policyHtml=escape(policyText);
    const amount=money(Math.max(0,Number(config.shippingThresholdCents || 6000)-totalEligible(state.model)),state.model.currency);
    if(policyText.startsWith(amount))policyHtml='<strong>'+escape(amount)+'</strong>'+escape(policyText.slice(amount.length));
    const policyNode=state.panel.querySelector('[data-auto-policy]');
    if(policyNode.innerHTML!==policyHtml)policyNode.innerHTML=policyHtml;
    const bar = state.panel.querySelector('[role="progressbar"]');
    bar.style.setProperty('--progress',result.progress+'%');
    bar.setAttribute('aria-valuenow',String(Math.round(result.progress)));
    bar.hidden=subscription(state.model) || (destination?.country && (destination.country!=='US' || ['AK','HI','AA','AE','AP','PR','VI','GU','MP','AS'].includes(destination.regionCode)));
    const place = destination ? [destination.regionCode,destination.postalCode,destination.country==='US'?null:destination.country].filter(Boolean).join(' ') || a.unknown : a.unknown;
    setText(state.panel,'[data-auto-location]',`${a.destination} ${place}${destination?.source === 'ip' ? ' · '+a.approximate : ''}`);
  };
  const ensure = (key,parent) => {
    let state = panels.get(key);
    if (state?.panel.isConnected) return state;
    if (state) { state.serial++; state.controller?.abort(); clearTimeout(state.timer); }
    const panel = document.createElement('section');
    panel.className = 'steep-auto-shipping ph-no-capture';
    panel.setAttribute('data-ph-no-capture','');
    panel.setAttribute('aria-label',a.heading);
    panel.innerHTML = `<div class="steep-auto-quote"><span>${escape(a.heading)}</span><strong data-auto-price aria-live="polite" aria-atomic="true">—</strong></div><div class="steep-auto-location-row"><span data-auto-location></span><button type="button" data-auto-change aria-expanded="false" aria-controls="steep-location-${key}">${escape(a.change)}</button></div><form id="steep-location-${key}" hidden><label>${escape(a.countryCode)}<input data-auto-country maxlength="2" autocapitalize="characters" autocomplete="off" required></label><label>${escape(a.regionCode)}<input data-auto-region maxlength="10" autocapitalize="characters" autocomplete="off"></label><label>${escape(t.zip)}<input data-auto-postal maxlength="12" autocapitalize="characters" autocomplete="off" required></label><button type="submit">${escape(a.apply)}</button></form><div class="steep-auto-track" role="progressbar" aria-label="${escape(a.progress)}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><div class="steep-auto-fill"></div></div><p data-auto-policy></p><p data-auto-status role="status" aria-live="polite" aria-atomic="true"></p><div class="steep-auto-footer"><small>${escape(a.checkout)}</small><details class="steep-auto-details"><summary>${escape(a.details)}</summary><p data-auto-service></p><p>${escape(a.checkout)}</p><p>${escape(a.privacy)}</p></details></div>`;
    parent.append(panel);
    state = {key,panel,serial:0,last:'',controller:null,timer:null,model:null};
    panels.set(key,state);
    const fill = () => {
      panel.querySelector('[data-auto-country]').value = destination?.country || window.Shopify?.country || 'US';
      panel.querySelector('[data-auto-region]').value = destination?.regionCode || '';
      panel.querySelector('[data-auto-postal]').value = destination?.postalCode || '';
    };
    fill();
    const correction=panel.querySelector('form');
    const change=panel.querySelector('[data-auto-change]');
    change.addEventListener('click',()=>{
      correction.hidden=!correction.hidden;
      change.setAttribute('aria-expanded',String(!correction.hidden));
      if(!correction.hidden)fill();
      else if(state.editing){state.editing=false;state.last='';if(state.model)update(state,state.model);}
    });
    panel.querySelector('form').addEventListener('input',() => {
      state.serial++; state.controller?.abort(); clearTimeout(state.timer); state.last='';state.editing=true;
      state.panel.removeAttribute('aria-busy');
      status(state,a.editing);
    });
    panel.querySelector('form').addEventListener('submit',event => {
      event.preventDefault();
      const candidate = {
        country:panel.querySelector('[data-auto-country]').value.trim().toUpperCase(),
        regionCode:panel.querySelector('[data-auto-region]').value.trim().toUpperCase(),
        postalCode:panel.querySelector('[data-auto-postal]').value.trim().toUpperCase(),source:'manual'
      };
      const old = destination;
      destination=candidate;
      if(!complete()) { destination=old; status(state,t.required); return; }
      locationPending=false; locationVersion++;state.editing=false;
      correction.hidden=true;change.setAttribute('aria-expanded','false');
      panels.forEach(s => {s.last=''; if(s.model) update(s,s.model);});
    });
    return state;
  };
  const jsonFetch = async (url,options,signal) => {
    const response = await fetch(url,{...options,signal,cache:'no-store'});
    if(!response.ok) throw new Error('Unavailable');
    return response.json();
  };
  const verifiedRates = (rates,code) => {
    if(!Array.isArray(rates) || !rates.length) throw new Error('No rates');
    return rates.map(rate => {
      const value=String(rate.price);
      if(!/^\d+(?:\.\d+)?$/.test(value) || !Number.isFinite(Number(value)) || !rate.name || (rate.currency && rate.currency!==code)) throw new Error('Invalid rate');
      return {name:rate.name,price:Number(value)};
    });
  };
  const cartRates = async (state,signal,current) => {
    const countryName = new Intl.DisplayNames(['en'],{type:'region'}).of(destination.country);
    const params = new URLSearchParams({'shipping_address[country]':countryName,'shipping_address[province]':destination.regionCode || '', 'shipping_address[zip]':destination.postalCode});
    const before = await jsonFetch(root+'cart.js',{credentials:'same-origin'},signal);
    if(fingerprint(before)!==fingerprint(state.model)) throw new Error('Changed cart');
    await jsonFetch(root+'cart/prepare_shipping_rates.json?'+params,{method:'POST',credentials:'same-origin'},signal);
    let payload;
    for(let i=0;i<8;i++) {
      if(!current()) throw new Error('Superseded');
      payload = await jsonFetch(root+'cart/async_shipping_rates.json?'+params,{credentials:'same-origin'},signal);
      if(payload!==null) break;
      await new Promise(resolve => setTimeout(resolve,750));
    }
    const after = await jsonFetch(root+'cart.js',{credentials:'same-origin'},signal);
    if(fingerprint(before)!==fingerprint(after)) throw new Error('Changed cart');
    return verifiedRates(payload?.shipping_rates,state.model.currency);
  };
  const api = 'https://prvibeauty.myshopify.com/api/2026-10/graphql.json';
  const createQuery = 'mutation EstimateCart($input: CartInput!) { cartCreate(input:$input) { userErrors { message } cart { id cost { subtotalAmount { amount currencyCode } } lines(first:10) { nodes { quantity merchandise { ... on ProductVariant { id } } } } } } }';
  const rateQuery = 'query EstimateRates($id:ID!) { cart(id:$id) { ...Rates @defer } } fragment Rates on Cart { deliveryGroups(first:10,withCarrierRates:true) { nodes { deliveryOptions { title estimatedCost { amount currencyCode } } } } }';
  const packRates = async (state,signal) => {
    const item=state.model.items[0];
    const input={lines:[{merchandiseId:'gid://shopify/ProductVariant/'+item.variant_id,quantity:item.quantity}],buyerIdentity:{countryCode:destination.country},delivery:{addresses:[{selected:true,oneTimeUse:true,address:{deliveryAddress:{countryCode:destination.country,provinceCode:destination.regionCode,zip:destination.postalCode}}}]}};
    const options = body => ({method:'POST',credentials:'omit',headers:{'Content-Type':'application/json',Accept:'application/json, multipart/mixed'},body:JSON.stringify(body)});
    const created=await jsonFetch(api,options({query:createQuery,variables:{input}}),signal);
    const result=created.data?.cartCreate;
    const cart=result?.cart;
    if(created.errors || result?.userErrors?.length || !cart?.id || cart.lines?.nodes?.length!==1 || cart.lines.nodes[0].quantity!==item.quantity || cart.lines.nodes[0].merchandise.id!=='gid://shopify/ProductVariant/'+item.variant_id || cart.cost.subtotalAmount.currencyCode!==state.model.currency || Math.round(Number(cart.cost.subtotalAmount.amount)*100)!==state.model.total_price) throw new Error('Pack mismatch');
    const response=await fetch(api,{...options({query:rateQuery,variables:{id:cart.id}}),signal,cache:'no-store'});
    if(!response.ok) throw new Error('Unavailable');
    const content=await response.text();
    const type=response.headers.get('content-type') || '';
    let payloads;
    if(type.includes('multipart/mixed')) {
      const boundary=type.match(/boundary="?([^";]+)/)?.[1];
      if(!boundary) throw new Error('Invalid stream');
      payloads=content.split('--'+boundary).filter(part=>part.includes('\r\n\r\n')).map(part=>JSON.parse(part.split('\r\n\r\n').slice(1).join('\r\n\r\n').trim()));
      if(!payloads.length || payloads.at(-1).hasNext!==false) throw new Error('Incomplete stream');
    } else payloads=[JSON.parse(content)];
    let groups=[];
    for(const payload of payloads) {
      if(payload.errors) throw new Error('Invalid rates');
      groups.push(...(payload.data?.cart?.deliveryGroups?.nodes || []));
      for(const patch of payload.incremental || []) {
        if(patch.errors) throw new Error('Invalid rates');
        groups.push(...(patch.data?.deliveryGroups?.nodes || []));
      }
    }
    if(groups.length!==1) throw new Error('Unavailable delivery group');
    return verifiedRates(groups[0].deliveryOptions.map(option=>({name:option.title,price:option.estimatedCost.amount,currency:option.estimatedCost.currencyCode})),state.model.currency);
  };
  const update = (state,model) => {
    state.model=model;
    updatePolicy(state);
    if(state.editing)return;
    const key=signature(model);
    if(state.last===key) return;
    state.last=key; state.serial++; state.controller?.abort(); clearTimeout(state.timer);
    const serial=state.serial;
    state.panel.removeAttribute('aria-busy');
    if(subscription(model)) {status(state,t.subscription);return;}
    if(isTrial(model)) {status(state,a.trialFallback);return;}
    if(!complete()) {status(state,locationPending?a.locating:a.missing);return;}
    if(state.key==='pdp' && ![4,12,24].includes(model.packSize)) {status(state,a.unavailable);return;}
    status(state,t.loading);
    state.timer=setTimeout(async()=>{
      const controller=new AbortController();state.controller=controller;
      const timeout=setTimeout(()=>controller.abort(),20000);
      const current=()=>state.serial===serial && state.panel.isConnected && !controller.signal.aborted;
      state.panel.setAttribute('aria-busy','true');
      try {
        const cached=cache.get(key);
        const rates=cached && Date.now()-cached.time<60000 ? cached.rates : await(state.key==='cart'?cartRates(state,controller.signal,current):packRates(state,controller.signal));
        if(!current())return;
        if(rates.some(rate=>rate.price===0) && !regionAllowed())throw new Error('Unverified free eligibility');
        if(cache.size>10)cache.clear();cache.set(key,{rates,time:Date.now()});
        const cheapest=rates.reduce((best,rate)=>rate.price<best.price?rate:best);
        status(state,'');
        setText(state.panel,'[data-auto-price]',money(Math.round(cheapest.price*100),model.currency));
        setText(state.panel,'[data-auto-service]',a.service.replace('{name}',cheapest.name));
      } catch(_) {if(current() || state.serial===serial)status(state,a.unavailable);}
      finally {clearTimeout(timeout);if(state.serial===serial)state.panel.removeAttribute('aria-busy');}
    },350);
  };
  const updateCart = (cart,drawer) => {
    cartModel=cart;
    drawer.querySelector('.steep-shipping-estimator')?.remove();
    drawer.querySelector('.steep-aov-shipping')?.remove();
    const parent=drawer.querySelector('.cart-drawer__items');
    if(!parent || !cart.item_count) {
      const state=panels.get('cart');
      if(state) {state.serial++;state.controller?.abort();clearTimeout(state.timer);state.panel.remove();}
      return;
    }
    update(ensure('cart',parent),cart);
  };
  const pdp = () => {
    const section=document.querySelector('[data-steep-pdp]');
    const input=section?.querySelector('[data-variant-input]');
    const source=section?.querySelector('[data-pdp-data]');
    if(!input || !source)return;
    let product;try {product=JSON.parse(source.textContent);}catch(_){return;}
    const variant=product.variants.find(v=>String(v.id)===input.value);
    if(!variant)return;
    const pack=config.packVariants.find(v=>String(v.id)===String(variant.id));
    const plan=section.querySelector('[data-plan-input]');
    const subscribed=plan && !plan.disabled && plan.value;
    const quantity=Math.max(1,Number(section.querySelector('[name="quantity"]')?.value || 1));
    const id=pack?.purchaseId || variant.id;
    const price=pack?.purchasePrice ?? variant.price;
    const model={currency,total_price:price*quantity,packSize:variant.count,items:[{variant_id:id,quantity,final_line_price:price*quantity,...(subscribed?{selling_plan_allocation:{selling_plan:{id:plan.value}}}:{})}]};
    const form=input.closest('form');
    const parent=form?.parentElement;
    if(!parent)return;
    update(ensure('pdp',parent),model);
    section.classList.add('steep-auto-shipping-ready');
  };
  let frame;
  const schedulePdp=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=null;pdp();});};
  const invalidateCart = () => {
    const state=panels.get('cart');
    if(!state)return;
    state.serial++;state.controller?.abort();clearTimeout(state.timer);state.last='';
    state.panel.removeAttribute('aria-busy');status(state,t.changed);
  };
  document.addEventListener('click',event=>{
    const control=event.target.closest('#cart-drawer button');
    if(control && !control.disabled && (control.hasAttribute('data-steep-pack') || control.hasAttribute('data-steep-bundle-action') || /Quantity|onLineItemRemove/.test(control.getAttribute('on:click') || '')))invalidateCart();
  },true);
  document.addEventListener('input',event=>{if(event.target.closest('#cart-drawer quantity-selector-component'))invalidateCart();},true);
  document.addEventListener('click',event=>{if(event.target.closest('[data-steep-pdp]') && !event.target.closest('.steep-auto-shipping'))schedulePdp();});
  document.addEventListener('change',event=>{if(!event.target.closest('.steep-auto-shipping'))schedulePdp();});
  window.addEventListener('popstate',schedulePdp);
  window.addEventListener('pageshow',schedulePdp);
  document.addEventListener('shopify:section:load',schedulePdp);
  window.SteepAutoShipping={updateCart};
  pdp();
  const initialVersion=locationVersion;
  const locationController=new AbortController();
  const locationTimeout=setTimeout(()=>locationController.abort(),4000);
  jsonFetch(a.endpoint,{credentials:'omit'},locationController.signal).then(location=>{
    if(initialVersion!==locationVersion)return;
    destination={country:typeof location.country==='string'?location.country.toUpperCase():null,regionCode:typeof location.regionCode==='string'?location.regionCode.toUpperCase():null,postalCode:typeof location.postalCode==='string'?location.postalCode.toUpperCase():null,source:'ip'};
  }).catch(()=>{}).finally(()=>{
    clearTimeout(locationTimeout);locationPending=false;
    panels.forEach(state=>{state.last='';if(state.model)update(state,state.model);});
  });
})();

(() => {
  const dataElement = document.getElementById('SteepAovCartData');
  const drawer = document.getElementById('cart-drawer');
  if (!dataElement || !drawer) return;

  let config;
  try {
    config = JSON.parse(dataElement.textContent || '{}');
  } catch (error) {
    console.error('[Steep cart] Cart configuration is invalid.', error);
    return;
  }

  const rootUrl = window.Shopify?.routes?.root || '/';
  const packVariants = (config.packVariants || [])
    .map((variant) => ({ ...variant, sellingPlans: (variant.sellingPlans || []).filter(plan => plan.price < variant.price), packSize: Number.parseInt(variant.title, 10) || 0 }))
    .filter((variant) => [4, 12, 24].includes(variant.packSize));
  const exclusiveOfferVariantIds = new Set((config.exclusiveOfferVariantIds || []).map(String));
  const drinkProductIds = new Set(
    [config.weightedPurchaseProductId, config.drinkProductId, config.bundleParentProductId, ...(config.legacyDrinkProductIds || [])]
      .filter(Boolean)
      .map(String)
  );
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: config.currency || 'USD',
  });
  let cartRequest;
  let cartRevision = 0;
  let renderFrame;
  let mutationPromise = Promise.resolve();

  const money = (cents) => formatter.format((Number(cents) || 0) / 100);
  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
  const properties = (item) => item?.properties || {};
  const bundleId = (item) => String(properties(item)['_appstle-bb-id'] || '');
  const isChild = (item) => String(properties(item)['_appstle-bb-child'] || '').toLowerCase() === 'true';
  const itemPlan = (item) => item?.selling_plan_allocation?.selling_plan || null;
  const variantFor = (item) => packVariants.find((variant) => (String(variant.id) === String(item.variant_id) || String(variant.purchaseId) === String(item.variant_id)));
  const packSize = (item) => {
    const configured = variantFor(item)?.packSize;
    if (configured) return configured;
    if ((config.legacyDrinkProductIds || []).map(String).includes(String(item.product_id))) return 4;
    return Number.parseInt(item.variant_title || '', 10) || 0;
  };
  const isDrinkParent = (item) => !isChild(item) && drinkProductIds.has(String(item.product_id));
  const isExclusiveOffer = (item) => Boolean(
    properties(item)['_Trial offer']
    || properties(item)['_Landing page']
    || exclusiveOfferVariantIds.has(String(item.variant_id))
  );
  const isStandardBundleParent = (item) => !isChild(item)
    && Boolean(variantFor(item))
    && !isExclusiveOffer(item);
  const isMixedOfferCart = (cart) => cart.items.some(isExclusiveOffer)
    && cart.items.some(isStandardBundleParent);

  const getCart = () => {
    if (!cartRequest) {
      cartRequest = fetch(`${rootUrl}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then((response) => {
        if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
        return response.json();
      }).finally(() => { cartRequest = null; });
    }
    return cartRequest;
  };

  const postCart = async (path, body) => {
    const response = await fetch(`${rootUrl}${path}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.description || payload.message || 'Cart update failed.');
    cartRevision += 1;
    cartRequest = null;
    return payload;
  };

  const refreshDrawer = async () => {
    const refreshUrl = new URL(window.location.href);
    refreshUrl.searchParams.set('section_id', 'cart-drawer-section');
    if (config.themeId && window.Shopify?.theme?.role === 'unpublished') refreshUrl.searchParams.set('preview_theme_id', String(config.themeId));
    else refreshUrl.searchParams.delete('preview_theme_id');
    const response = await fetch(refreshUrl.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) throw new Error('Could not refresh the cart drawer.');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = parsed.getElementById('shopify-section-cart-drawer-section');
    const current = document.getElementById('shopify-section-cart-drawer-section');
    if (!next || !current) throw new Error('Cart drawer section was unavailable.');
    const wasOpen = current.querySelector('#cart-drawer')?.hasAttribute('open');
    current.replaceChildren(...next.childNodes);
    if (wasOpen) document.getElementById('cart-drawer')?.open?.();
    scheduleRender();
  };

  // Separate new purchases from zero-weight legacy Appstle renewal parents.
  // Fail before changing the cart if catalog/plan staging is incomplete.
  const bundleLines = (variant, quantity = 1, sellingPlan = null) => {
    // Draft-theme staging keeps the current purchase path until all global gates pass.
    if (config.weightedPurchaseEnabled !== true) {
      return [{ id: Number(variant.id), quantity, ...(sellingPlan ? { selling_plan: Number(sellingPlan) } : {}) }];
    }
    const id = Number(variant.purchaseId);
    const configuredPlans = variant.sellingPlans || [];
    const purchasePlans = variant.purchaseSellingPlans || [];
    const sourcePlan = configuredPlans.find(plan => String(plan.id) === String(sellingPlan));
    const purchasePlan = purchasePlans.find(plan => String(plan.id) === String(sellingPlan));
    if (!Number.isSafeInteger(id) || id <= 0 || id === Number(variant.id)
      || !config.weightedPurchaseProductId || !variant.purchaseAvailable
      || Number(variant.purchasePrice) !== Number(variant.price)
      || (sellingPlan && (!sourcePlan || !purchasePlan
        || Number(sourcePlan.price) !== Number(purchasePlan.price)))) {
      throw new Error('This pack is temporarily unavailable. Please try again shortly.');
    }
    return [{ id, quantity, ...(sellingPlan ? { selling_plan: Number(sellingPlan) } : {}) }];
  };

  const groups = (cart) => {
    const result = new Map();
    cart.items.forEach((item) => {
      const id = bundleId(item);
      if (!id) return;
      if (!result.has(id)) result.set(id, { parents: [], children: [] });
      result.get(id)[isChild(item) ? 'children' : 'parents'].push(item);
    });
    return result;
  };

  const removeExclusiveOfferState = async (cart, force = false) => {
    const current = cart || await getCart();
    if (!force && !isMixedOfferCart(current)) return current;
    const exclusiveLines = current.items.filter(isExclusiveOffer);
    if (!exclusiveLines.length) return current;
    const updates = {};
    exclusiveLines.forEach((item) => { updates[item.key] = 0; });
    await postCart('cart/update.js', { updates });
    const verified = await getCart();
    if (verified.items.some(isExclusiveOffer)) throw new Error('The previous landing-page offer could not be removed safely.');
    return verified;
  };

  const normalizeBundles = async () => {
    const cart = await removeExclusiveOfferState(await getCart());
    const legacyParents = cart.items.filter((item) => isStandardBundleParent(item) && (Boolean(bundleId(item)) || (config.weightedPurchaseEnabled === true && String(item.variant_id) === String(variantFor(item).id))));
    const legacyChildren = cart.items.filter(isChild);
    if (!legacyParents.length && !legacyChildren.length) return cart;

    const updates = {};
    const additions = legacyParents.map((item) => bundleLines(
      variantFor(item),
      Number(item.quantity) || 1,
      itemPlan(item)?.id
    )[0]);
    legacyParents.forEach((item) => { updates[item.key] = 0; });
    legacyChildren.forEach((item) => { updates[item.key] = 0; });

    if (additions.length) await postCart('cart/add.js', { items: additions });
    await postCart('cart/update.js', { updates });
    const verified = await getCart();
    if (verified.items.some(isChild)
      || verified.items.some((item) => isStandardBundleParent(item) && (Boolean(bundleId(item)) || (config.weightedPurchaseEnabled === true && String(item.variant_id) === String(variantFor(item).id))))) {
      throw new Error('Legacy bundle lines could not be removed safely.');
    }
    return verified;
  };

  const addStandardBundle = async (items) => {
    setDrawerBusy(true);
    const operation = mutationPromise.then(async () => {
      const incoming = items.filter(item => String(item.properties?.['_appstle-bb-child'] || '').toLowerCase() !== 'true');
      const target = incoming[0];
      if (incoming.length !== 1 || !packVariants.some(v => String(v.id) === String(target.id))) {
        throw new Error('Please choose one Steep pack.');
      }
      const nativeLine = bundleLines(
        packVariants.find((variant) => String(variant.id) === String(target.id)),
        Number(target.quantity) || 1,
        target.selling_plan
      )[0];
      // Add first so an unavailable replacement leaves the customer's previous pack intact.
      await postCart('cart/add.js', { items: [nativeLine] });
      const afterAdd = await getCart();
      const keep = afterAdd.items.find(item => !isChild(item)
        && String(item.variant_id) === String(nativeLine.id)
        && String(itemPlan(item)?.id || '') === String(target.selling_plan || '')
        && !bundleId(item));
      if (!keep) throw new Error('The selected pack could not be verified.');
      const updates = { [keep.key]: Number(target.quantity) || 1 };
      afterAdd.items.forEach(item => {
        if (item.key === keep.key) return;
        if (isDrinkParent(item) || isExclusiveOffer(item) || isChild(item)) updates[item.key] = 0;
      });
      await postCart('cart/update.js', { updates });
      const verified = await normalizeBundles();
      if (verified.items.filter(isDrinkParent).length !== 1 || verified.items.some(isExclusiveOffer)) {
        throw new Error('The selected pack could not be confirmed. Please review your cart.');
      }
      // Keep old controls locked until the new line and section are both ready.
      await refreshDrawer();
      document.dispatchEvent(new CustomEvent('steep:cart-add-confirmed', { detail: { variantId: target.id } }));
      return verified;
    });
    mutationPromise = operation.catch(() => {}).finally(() => setDrawerBusy(false));
    return operation;
  };

  const matchPlan = (item, target) => {
    const source = itemPlan(item);
    if (!source) return null;
    const plans = target.sellingPlans || [];
    return plans.find((plan) => String(plan.id) === String(source.id))
      || plans.find((plan) => String(plan.name).toLowerCase() === String(source.name).toLowerCase())
      || null;
  };

  const setDrawerBusy = (busy) => {
    const currentDrawer = document.getElementById('cart-drawer');
    if (!currentDrawer) return;
    currentDrawer.classList.toggle('steep-cart-updating', busy);
    if (busy) {
      currentDrawer.setAttribute('aria-busy', 'true');
      currentDrawer.querySelectorAll('.cart-items__quantity-controls button, .cart-items__quantity-controls input, [data-steep-pack], [name="checkout"], #_si-sec-checkout-id, ._si-checkout-without-protection').forEach((control) => {
        if (!control.hasAttribute('data-steep-busy-disabled')) control.setAttribute('data-steep-busy-disabled', String(control.disabled));
        control.disabled = true;
      });
      if (!currentDrawer.querySelector('.steep-cart-update-status')) {
        const status = document.createElement('div');
        status.className = 'steep-cart-update-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.textContent = 'Updating your cart…';
        currentDrawer.querySelector('.theme-drawer__dialog')?.append(status);
      }
      return;
    }
    currentDrawer.removeAttribute('aria-busy');
    currentDrawer.querySelectorAll('[data-steep-busy-disabled]').forEach((control) => {
      control.disabled = control.getAttribute('data-steep-busy-disabled') === 'true';
      control.removeAttribute('data-steep-busy-disabled');
    });
    currentDrawer.querySelector('.steep-cart-update-status')?.remove();
  };

  const replacePack = async (targetId, button) => {
    const target = packVariants.find((variant) => String(variant.id) === String(targetId));
    if (!target?.available) throw new Error('That pack is not currently available.');
    const cart = await normalizeBundles();
    const source = cart.items.find(isDrinkParent);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (!source) {
      await postCart('cart/add.js', { items: bundleLines(target) });
    } else {
      const plan = matchPlan(source, target);
      if (itemPlan(source) && !plan) throw new Error('The same subscription schedule is unavailable for that pack.');
      await postCart('cart/add.js', { items: bundleLines(target, Number(source.quantity) || 1, plan?.id) });
      const afterAdd = await getCart();
      const sourceId = bundleId(source);
      const removals = {};
      if (sourceId) {
        afterAdd.items.filter((item) => bundleId(item) === sourceId).forEach((item) => { removals[item.key] = 0; });
      } else {
        const sourcePlanId = itemPlan(source)?.id;
        afterAdd.items.filter((item) =>
          item.key === source.key
          || (String(item.variant_id) === String(source.variant_id)
            && String(itemPlan(item)?.id || '') === String(sourcePlanId || ''))
        ).forEach((item) => { removals[item.key] = 0; });
      }
      await postCart('cart/update.js', { updates: removals });
      const afterRemove = await getCart();
      const survivors = afterRemove.items.filter((item) => sourceId
        ? bundleId(item) === sourceId
        : String(item.variant_id) === String(source.variant_id));
      if (survivors.length) {
        const retry = {};
        survivors.forEach((item) => { retry[item.key] = 0; });
        await postCart('cart/update.js', { updates: retry });
      }
    }
    await normalizeBundles();
    await refreshDrawer();
  };

  const updateBundleQuantity = async (row, quantity) => {
    const cart = await getCart();
    const id = row.dataset.steepBundleId;
    const source = cart.items.find((item) => item.key === row.dataset.steepParentKey);
    const group = groups(cart).get(id);
    if (!source || !group?.children?.length) throw new Error('This pack could not be verified.');
    const updates = { [source.key]: Math.max(0, quantity) };
    const expected = group.parents.reduce((total, item) => {
      const count = item.key === source.key ? Math.max(0, quantity) : Number(item.quantity || 0);
      return total + packSize(item) * count;
    }, 0);
    updates[group.children[0].key] = expected;
    group.children.slice(1).forEach((item) => { updates[item.key] = 0; });
    await postCart('cart/update.js', { updates });
    await normalizeBundles();
    await refreshDrawer();
  };

  const card = (variant, current, hasSubscription) => {
    const saving = current && !hasSubscription ? Math.max(0, Math.round((1 - (variant.price / variant.packSize) / (current.price / current.packSize)) * 100)) : 0;
    return `<button class="steep-aov-upgrade-card${variant.packSize === 24 ? ' steep-aov-upgrade-card--primary' : ''}" type="button" data-steep-pack="${escapeHtml(variant.id)}" data-target-pack-size="${variant.packSize}">
      <span class="steep-aov-upgrade-card__top"><span><strong class="steep-aov-upgrade-card__pack">${variant.packSize} Pack</strong><span class="steep-aov-upgrade-card__price">${escapeHtml(money(variant.price))}</span><span class="steep-aov-upgrade-card__value">${escapeHtml(money(variant.price / variant.packSize))} / can${saving ? ` · ${saving}% less per can` : ''}</span></span>${variant.image ? `<img class="steep-aov-upgrade-card__image" src="${escapeHtml(variant.image)}" alt="${variant.packSize} pack of Steep">` : ''}</span>
      <span class="steep-aov-upgrade-card__action">${current ? `Upgrade to ${variant.packSize}` : `Add the ${variant.packSize} pack`}</span>
    </button>`;
  };

  // Messages use variant identity and eligible paid merchandise, matching the staged shipping rule.
  const shippingStatus = (cart, threshold) => {
    const eligibleIds = new Set((config.shippingEligibleVariantIds || []).map(String));
    const trialIds = new Set((config.freeShippingTrialVariantIds || []).map(String));
    const paid = (cart.items || []).filter(item => Number(item.final_line_price ?? item.line_price ?? 0) > 0);
    const trialOnly = paid.length > 0 && paid.every(item => trialIds.has(String(item.variant_id ?? item.id)));
    const eligible = paid.reduce((sum, item) => eligibleIds.has(String(item.variant_id ?? item.id))
      ? sum + Number(item.final_line_price ?? item.line_price ?? 0) : sum, 0);
    if (!threshold) return {mode: 'calculated', remaining: 0, progress: 0};
    if (trialOnly) return {mode: 'trial', remaining: 0, progress: 100};
    return {mode: 'threshold', remaining: Math.max(0, threshold - eligible),
      progress: Math.min(100, Math.max(0, eligible / threshold * 100))};
  };

  const renderShipping = (cart, currentDrawer) => {
    const summary = currentDrawer.querySelector('.cart-drawer__summary');
    if (!summary || !cart.item_count) return;
    let shipping = summary.querySelector('.steep-aov-shipping');
    if (!shipping) {
      shipping = document.createElement('div');
      shipping.className = 'steep-aov-shipping';
      summary.prepend(shipping);
    }
    const threshold = Number(config.shippingThresholdCents || 0);
    const {mode, remaining, progress} = shippingStatus(cart, threshold);
    const shippingMessage = mode === 'calculated' ? 'Shipping calculated at checkout'
      : mode === 'trial' ? 'Tasting offer: eligible lower-48 standard shipping included'
      : remaining ? `${escapeHtml(money(remaining))} away from free shipping`
      : 'Eligible shipping threshold reached';
    shipping.style.setProperty('--steep-shipping-progress', `${progress}%`);
    shipping.innerHTML = `<div class="steep-aov-shipping__status"><span>${shippingMessage}</span><small>${escapeHtml(config.shippingEligibilityLabel || '')}</small></div><div class="steep-aov-shipping__track" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><div class="steep-aov-shipping__fill"></div></div>`;
  };

  // Destination inputs stay in this disclosure, never analytics or cart attributes.
  const estimateText = config.shippingEstimator;
  let estimateSerial = 0;
  let estimateController;
  let estimateCartSignature = '';
  const estimateFingerprint = (cart) => JSON.stringify([
    cart.currency, cart.total_price,
    cart.items.map(item => [item.key, item.quantity, item.final_line_price, itemPlan(item)?.id || null]),
  ]);
  const invalidateEstimate = (panel, message = '') => {
    estimateSerial += 1;
    estimateController?.abort();
    panel.removeAttribute('aria-busy');
    const button = panel.querySelector('[data-shipping-estimate]');
    if (button) button.disabled = false;
    const status = panel.querySelector('[data-shipping-status]');
    if (status && status.textContent !== message) status.textContent = message;
    panel.querySelector('[data-shipping-rates]')?.replaceChildren();
  };
  const populateEstimateProvinces = (panel) => {
    const country = panel.querySelector('[data-shipping-country]');
    const province = panel.querySelector('[data-shipping-province]');
    let provinces = [];
    try { provinces = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) { /* Checkout fallback remains available. */ }
    province.replaceChildren(new Option(estimateText.choose, ''));
    provinces.forEach(([value, label]) => province.add(new Option(label, value)));
    province.disabled = !provinces.length;
    province.closest('label').hidden = !provinces.length;
  };
  const renderShippingEstimator = (cart, currentDrawer) => {
    const items = currentDrawer.querySelector('.cart-drawer__items');
    if (!estimateText || !items) return;
    let panel = items.querySelector('.steep-shipping-estimator');
    if (!cart.item_count) { if (panel) { invalidateEstimate(panel); panel.remove(); } return; }
    if (!panel) {
      panel = document.createElement('details');
      panel.className = 'steep-shipping-estimator ph-no-capture';
      panel.setAttribute('data-ph-no-capture', '');
      panel.innerHTML = `<style>.steep-shipping-estimator{border-top:1px solid currentColor;margin:12px 0;padding:0 0 12px;font-size:14px}.steep-shipping-estimator summary{min-height:44px;padding:12px 0;cursor:pointer;font-weight:600;box-sizing:border-box}.steep-shipping-estimator summary:focus-visible,.steep-shipping-estimator button:focus-visible{outline:2px solid currentColor;outline-offset:3px}.steep-shipping-estimator label{display:block;margin:10px 0}.steep-shipping-estimator label[hidden]{display:none}.steep-shipping-estimator select,.steep-shipping-estimator input{display:block;width:100%;max-width:100%;min-height:44px;font:inherit;padding:8px;border:1px solid currentColor;border-radius:4px;background:transparent;color:inherit;box-sizing:border-box}.steep-shipping-estimator button{min-height:44px;padding:8px 12px;border:1px solid currentColor;border-radius:4px;background:transparent;color:inherit;cursor:pointer;font:inherit}.steep-shipping-estimator p{margin:8px 0;line-height:1.4}.steep-shipping-estimator ul{margin:8px 0;padding-left:20px}.steep-shipping-estimator small{display:block;line-height:1.4;margin-top:8px}</style>
        <summary>${escapeHtml(estimateText.summary)}</summary>
        <p>${escapeHtml(estimateText.intro)}</p><p data-shipping-subscription></p>
        <div data-shipping-inputs><label>${escapeHtml(estimateText.country)}<select data-shipping-country autocomplete="off">${estimateText.countries}</select></label>
        <label>${escapeHtml(estimateText.province)}<select data-shipping-province autocomplete="off"></select></label>
        <label>${escapeHtml(estimateText.zip)}<input data-shipping-zip type="text" maxlength="20" autocomplete="off"></label>
        <button type="button" data-shipping-estimate>${escapeHtml(estimateText.button)}</button></div>
        <p data-shipping-status role="status" aria-live="polite" aria-atomic="true"></p><ul data-shipping-rates></ul>
        <small>${escapeHtml(estimateText.privacy)}</small>`;
      items.append(panel);
      const country = panel.querySelector('[data-shipping-country]');
      if ([...country.options].some(option => option.value === 'United States')) country.value = 'United States';
      populateEstimateProvinces(panel);
      panel.addEventListener('input', () => invalidateEstimate(panel));
      country.addEventListener('change', () => { populateEstimateProvinces(panel); invalidateEstimate(panel); });
      panel.querySelector('[data-shipping-estimate]').addEventListener('click', () => requestShippingEstimate(panel));
      panel.querySelector('[data-shipping-zip]').addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); if (!panel.querySelector('[data-shipping-estimate]').disabled) requestShippingEstimate(panel); }
      });
    }
    const signature = estimateFingerprint(cart);
    if (estimateCartSignature && signature !== estimateCartSignature) invalidateEstimate(panel, estimateText.changed);
    estimateCartSignature = signature;
    const note = panel.querySelector('[data-shipping-subscription]');
    const hasSubscription = cart.items.some(item => itemPlan(item));
    panel.querySelector('[data-shipping-inputs]').hidden = hasSubscription;
    const subscriptionNote = hasSubscription ? estimateText.subscription : '';
    if (note.textContent !== subscriptionNote) note.textContent = subscriptionNote;
    note.hidden = !subscriptionNote;
  };
  const estimateRequest = async (path, method, params, signal) => {
    const response = await fetch(`${rootUrl}${path}?${params}`, {
      method, credentials: 'same-origin', signal, headers: { Accept: 'application/json' }, cache: 'no-store',
    });
    if (!response.ok) throw new Error('Shipping estimate unavailable');
    return response.json();
  };
  const pollShippingRates = async (params, signal, isCurrent) => {
    await estimateRequest('cart/prepare_shipping_rates.json', 'POST', params, signal);
    for (let attempt = 0; attempt < 8; attempt += 1) {
      if (!isCurrent()) throw new Error('Superseded estimate');
      const payload = await estimateRequest('cart/async_shipping_rates.json', 'GET', params, signal);
      if (payload !== null) {
        if (!Array.isArray(payload.shipping_rates)) throw new Error('Invalid rates');
        return payload.shipping_rates;
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    throw new Error('Shipping estimate timed out');
  };
  const verifiedEstimateRates = (rates, currency) => rates.map(rate => {
    if (!/^\d+(?:\.\d+)?$/.test(String(rate.price)) || !Number.isFinite(Number(rate.price))
      || (rate.currency && rate.currency !== currency)
      || typeof rate.name !== 'string' || !rate.name.trim()) throw new Error('Invalid shipping rate');
    return {name: rate.name, price: Number(rate.price)};
  });
  const requestShippingEstimate = async (panel) => {
    invalidateEstimate(panel);
    const serial = estimateSerial;
    const status = panel.querySelector('[data-shipping-status]');
    const button = panel.querySelector('[data-shipping-estimate]');
    const country = panel.querySelector('[data-shipping-country]').value;
    const province = panel.querySelector('[data-shipping-province]');
    const zip = panel.querySelector('[data-shipping-zip]').value.trim();
    if (!country || !zip || (!province.disabled && !province.value)) { status.textContent = estimateText.required; return; }
    const params = new URLSearchParams({
      'shipping_address[country]': country, 'shipping_address[zip]': zip,
      ...(province.disabled ? {} : {'shipping_address[province]': province.value}),
    });
    const controller = new AbortController();
    estimateController = controller;
    const current = () => serial === estimateSerial && panel.isConnected && !controller.signal.aborted;
    const timeout = setTimeout(() => controller.abort(), 20000);
    button.disabled = true;
    panel.setAttribute('aria-busy', 'true');
    status.textContent = estimateText.loading;
    try {
      cartRequest = null;
      const cart = await getCart();
      if (!current()) return;
      if (cart.items.some(item => itemPlan(item))) { status.textContent = estimateText.subscription; return; }
      const signature = estimateFingerprint(cart);
      estimateCartSignature = signature;
      const rates = await pollShippingRates(params, controller.signal, current);
      cartRequest = null;
      const verifiedCart = await getCart();
      if (!current()) return;
      if (signature !== estimateFingerprint(verifiedCart)) { invalidateEstimate(panel, estimateText.changed); return; }
      const currency = cart.currency || config.currency;
      const displayRates = verifiedEstimateRates(rates, currency);
      status.textContent = displayRates.length ? `${estimateText.ready} ${estimateText.currency} ${currency}.` : estimateText.empty;
      const list = panel.querySelector('[data-shipping-rates]');
      displayRates.forEach(rate => {
        const item = document.createElement('li');
        item.textContent = `${rate.name} — ${new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency}).format(rate.price)}`;
        list.append(item);
      });
    } catch (_) {
      if (serial === estimateSerial && panel.isConnected) status.textContent = estimateText.error;
    } finally {
      clearTimeout(timeout);
      if (serial === estimateSerial && panel.isConnected) { panel.removeAttribute('aria-busy'); button.disabled = false; }
    }
  };

  const render = async () => {
    const currentDrawer = document.getElementById('cart-drawer');
    if (!currentDrawer) return;
    const revision = cartRevision;
    const cart = await getCart().catch(() => null);
    if (!cart) return;
    if (revision !== cartRevision) {
      scheduleRender();
      return;
    }
    const grouped = groups(cart);
    const rows = new Map([...currentDrawer.querySelectorAll('.cart-items__table-row')].map((row) => [row.dataset.key, row]));
    const currentKeys = new Set(cart.items.map((item) => item.key));
    rows.forEach((row, key) => {
      if (key && !currentKeys.has(key)) {
        row.remove();
        rows.delete(key);
      }
    });
    currentDrawer.querySelectorAll('[data-cart-subtotal]').forEach((node) => {
      const total = money(cart.total_price);
      node.textContent = total;
      node.setAttribute('value', total);
    });
    currentDrawer.querySelectorAll('.cart-items__table > caption span').forEach((node) => {
      node.textContent = money(cart.total_price);
    });
    grouped.forEach(({ parents, children }, id) => {
      children.forEach((item) => {
        const row = rows.get(item.key);
        if (row) { row.hidden = true; row.setAttribute('aria-hidden', 'true'); }
      });
      parents.forEach((item) => {
        const row = rows.get(item.key);
        const variant = variantFor(item);
        if (!row || !variant) return;
        row.dataset.steepBundleId = id;
        row.dataset.steepParentKey = item.key;
        row.dataset.steepVariantId = String(item.variant_id);
        row.dataset.steepParentQuantity = String(item.quantity);
        row.classList.add('steep-aov-bundle-parent');
        const controls = row.querySelector('.cart-items__quantity-controls');
        if (controls && !controls.querySelector('[data-steep-bundle-action]')) controls.innerHTML = `<div class="steep-aov-linked-quantity" aria-label="Quantity for ${variant.packSize} pack"><button type="button" data-steep-bundle-action="decrease" aria-label="Decrease ${variant.packSize} pack quantity">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-steep-bundle-action="increase" aria-label="Increase ${variant.packSize} pack quantity">+</button></div><button type="button" class="steep-aov-linked-remove" data-steep-bundle-action="remove" aria-label="Remove ${variant.packSize} pack">Remove</button>`;
      });
    });
    const linkedChildKeys = new Set(
      [...grouped.values()]
        .filter(({ parents }) => parents.some((item) => variantFor(item)))
        .flatMap(({ children }) => children.map((item) => item.key))
    );
    const logicalCount = cart.items
      .filter((item) => !linkedChildKeys.has(item.key))
      .reduce((total, item) => total + Number(item.quantity || 0), 0);
    document.querySelectorAll('.cart-bubble__text-count').forEach((node) => { node.textContent = String(logicalCount); });
    currentDrawer.querySelectorAll('.theme-drawer__badge, [ref="cartItemCount"]').forEach((node) => { node.textContent = String(logicalCount); });
    [...currentDrawer.querySelectorAll('*')].filter((node) => node.children.length === 0 && /^total items in cart:\s*\d+$/i.test(node.textContent?.trim() || '')).forEach((node) => { node.textContent = `Total items in cart: ${logicalCount}`; });
    if (window.SteepAutoShipping) window.SteepAutoShipping.updateCart(cart, currentDrawer);
    else { renderShipping(cart, currentDrawer); renderShippingEstimator(cart, currentDrawer); }
    const content = currentDrawer.querySelector('.cart-drawer__content');
    const items = currentDrawer.querySelector('.cart-drawer__items');
    if (!content || !items || !cart.item_count) return;
    let extras = content.querySelector('.steep-aov-extras');
    if (!extras) {
      extras = document.createElement('div');
      extras.className = 'steep-aov-extras';
      items.append(extras);
    }
    const source = cart.items.find(isDrinkParent);
    const configuredCurrent = source ? variantFor(source) : null;
    const currentVariant = configuredCurrent || (source ? { packSize: packSize(source) || 4, price: Number(source.final_price || source.price || 0) } : null);
    const choices = packVariants.filter((variant) => variant.available && (!currentVariant || variant.packSize > currentVariant.packSize));
    const markup = choices.length ? `<section class="steep-aov-section steep-aov-offers" aria-label="Larger packs"><style>.steep-aov-pack-disclosure > summary:focus-visible{outline:2px solid currentColor;outline-offset:3px}.steep-aov-pack-disclosure__icon{margin-left:8px;font-size:20px;line-height:1}.steep-aov-pack-disclosure__icon::before{content:"+"}.steep-aov-pack-disclosure[open] > summary .steep-aov-pack-disclosure__icon::before{content:"−"}</style><details class="steep-aov-pack-disclosure"><summary style="min-height:44px;box-sizing:border-box;padding:12px 0;cursor:pointer;font-weight:600;">See larger packs <small aria-hidden="true" style="font-weight:400;margin-left:8px;">Optional</small><span class="steep-aov-pack-disclosure__icon" aria-hidden="true"></span></summary><div class="steep-aov-upgrade-grid${choices.length === 1 ? ' steep-aov-upgrade-grid--single' : ''}">${choices.map((variant) => card(variant, currentVariant, cart.items.some((item) => itemPlan(item)))).join('')}</div></details><p class="steep-aov-feedback" role="status" aria-live="polite"></p></section>` : '';
    if (extras.dataset.signature !== markup) {
      extras.innerHTML = markup;
      extras.dataset.signature = markup;
    }
  };

  const scheduleRender = () => {
    if (renderFrame) return;
    renderFrame = requestAnimationFrame(() => { renderFrame = 0; render(); });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-steep-pack]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setDrawerBusy(true);
    mutationPromise = mutationPromise.then(() => replacePack(button.dataset.steepPack, button)).catch((error) => {
      const feedback = document.querySelector('.steep-aov-feedback');
      if (feedback) feedback.textContent = error.message || 'Could not update the cart.';
      setDrawerBusy(false);
      const currentButton = document.querySelector(`[data-steep-pack="${CSS.escape(button.dataset.steepPack || '')}"]`);
      if (currentButton) {
        currentButton.disabled = false;
        currentButton.removeAttribute('aria-busy');
      }
    });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-steep-bundle-action]');
    const row = button?.closest('.steep-aov-bundle-parent');
    if (!button || !row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const current = Number(row.dataset.steepParentQuantity || 1);
    const action = button.dataset.steepBundleAction;
    const quantity = action === 'remove' ? 0 : action === 'decrease' ? Math.max(0, current - 1) : current + 1;
    mutationPromise = mutationPromise.then(() => updateBundleQuantity(row, quantity)).catch((error) => console.error('[Steep cart] Bundle update failed.', error));
  }, true);

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('#cart-drawer [name="checkout"], #cart-drawer a[href^="/checkout"]');
    if (!checkout || checkout.dataset.steepVerified === 'true') return;
    const isShipInsureCheckout = checkout.id === '_si-sec-checkout-id'
      || [...checkout.classList].some((className) => className.startsWith('_si-checkout-'));
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.disabled = true;
    mutationPromise = mutationPromise.then(normalizeBundles).then(async () => {
      checkout.dataset.steepVerified = 'true';
      checkout.disabled = false;
      if (isShipInsureCheckout) {
        await document.getElementById('cart-drawer')?.close?.();
        checkout.click();
      } else {
        // Checkout navigation must not wait for a drawer animation to finish.
        window.location.assign('/checkout');
      }
    }).catch((error) => {
      checkout.disabled = false;
      console.error('[Steep cart] Checkout blocked because pack integrity could not be verified.', error);
    });
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const currentDrawer = document.getElementById('cart-drawer');
    if (!link || !currentDrawer?.hasAttribute('open') || link.closest('#cart-drawer')) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.href === window.location.href) return;
    currentDrawer.close?.();
  }, true);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.target.closest?.('#shopify-section-cart-drawer-section'))) scheduleRender();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleRender);
  window.addEventListener('pageshow', () => {
    cartRequest = null;
    // A restored page can have stale/empty rows even though checkout kept the cart.
    // Rendering totals alone cannot create missing rows; rebuild the section first.
    setDrawerBusy(true);
    mutationPromise = mutationPromise.then(refreshDrawer).catch((error) => {
      console.error('[Steep cart] Could not refresh the restored cart.', error);
    }).finally(() => {
      setDrawerBusy(false);
      scheduleRender();
    });
  });
  window.SteepCart = {
    open: () => document.getElementById('cart-drawer')?.open?.(),
    refresh: refreshDrawer,
    normalize: normalizeBundles,
    addStandardBundle,
  };
  scheduleRender();
  if (new URLSearchParams(window.location.search).get('open_cart') === '1') {
    customElements.whenDefined('theme-drawer').then(() => document.getElementById('cart-drawer')?.open?.());
  }
})();
